import { motion } from "framer-motion";
import { CONTACT } from "@/data/site";
import { BlueprintGrid } from "./Blueprint";
import { EASE } from "./motion";

const WORD = "Carvings".split("");

export const Footer = () => (
  <footer className="relative border-t border-stone-200 bg-[#F4F3EE] overflow-hidden" data-testid="site-footer">
    <BlueprintGrid className="opacity-70" />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-14">
      <motion.p
        className="font-serif font-light text-5xl sm:text-7xl lg:text-8xl tracking-tight text-stone-900 flex"
        initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.4 }} transition={{ staggerChildren: 0.05 }}
        aria-label="Carvings"
      >
        {WORD.map((ch, i) => (
          <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
            <motion.span className="block" variants={{ hidden: { y: "110%" }, show: { y: 0 } }} transition={{ duration: 0.9, ease: EASE }}>{ch}</motion.span>
          </span>
        ))}
        <motion.span className="text-[#B85C38]" variants={{ hidden: { opacity: 0, scale: 0 }, show: { opacity: 1, scale: 1 } }} transition={{ type: "spring", stiffness: 300, damping: 14 }}>.</motion.span>
      </motion.p>
      <motion.div initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.5, ease: EASE }}
        className="mt-10 flex flex-col md:flex-row justify-between gap-4 font-mono text-xs uppercase tracking-[0.15em] text-stone-500">
        <span>© {new Date().getFullYear()} Carvings Architecture · Carvings Group</span>
        <div className="flex flex-wrap gap-x-6 gap-y-3">
          <a href={`mailto:${CONTACT.email}`} className="link-line hover:text-stone-900 py-1" data-testid="footer-email-link">{CONTACT.email}</a>
          <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="link-line hover:text-stone-900 py-1" data-testid="footer-instagram-link">Instagram</a>
          <a href={CONTACT.google} target="_blank" rel="noopener noreferrer" className="link-line hover:text-stone-900 py-1" data-testid="footer-google-link">Google</a>
          <a href={CONTACT.ga6} target="_blank" rel="noopener noreferrer" className="link-line hover:text-stone-900 py-1" data-testid="footer-ga6-link">GA6 Microcement</a>
          <a href="/staff" className="link-line hover:text-stone-900 py-1" data-testid="footer-staff-link">Staff</a>
        </div>
      </motion.div>
    </div>
  </footer>
);
